import {PeticionGET} from "services-comun/modules/net/request/peticion/get";
import type {Respuesta} from "services-comun/modules/net/request/respuesta";
import parser from "services-comun/modules/net/request/parser/respuesta";

import type {DominioTiempo} from "../../../portal/tiempo";
import type {IDataV4, IRespuestaNewsLast, TListadoNewsLast} from "../../interface";

class ArticulosFrontend {
    /* INSTANCE */
    // private readonly mr_services;

    public constructor() {
        // this.mr_services = "services.meteored.com";
        // if (!PRODUCCION) {
        //     this.mr_services = "local-services.meteored.com";
        // } else if (TEST) {
        //     this.mr_services = "test-services.meteored.com";
        // } else {
        //     this.mr_services = "services.meteored.com";
        // }
    }

    private async getRespuesta<T>(url: string): Promise<Respuesta<T>> {
        return  PeticionGET.run<T>(url, parser);
    }

    public async searchLastWebV4(dominio: DominioTiempo, idioma: string, tipo: number): Promise<Respuesta<IDataV4<TListadoNewsLast, IRespuestaNewsLast>>> {
        const mr_services: string = !PRODUCCION?
            dominio.servicesMR.replace("local-", ""):
            (
                TEST?
                    dominio.servicesMR.replace("test-", ""):
                    dominio.servicesMR
            );
        return this.getRespuesta<IDataV4<TListadoNewsLast, IRespuestaNewsLast>>(`${mr_services}/web/search/news/v4/last/${dominio.id}/${idioma}/${tipo}/`);
    }
}

const DS = new ArticulosFrontend();
export {DS as ArticulosFrontend};
